<template>
  <router-link :to="{ name: 'cart', params: {} }">
    <div class="cart-item d-flex pt-4 pb-4">
      <font-awesome-icon
        :icon="['fa', 'shopping-cart']"
        size="lg"
        class="mr-3"
      />
      <strong class="mr-2">WINKELWAGEN</strong>
      <div class="number-of-items">
        {{ numberOfItems }}
      </div>
    </div>
  </router-link>
</template>


<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("cart");

export default {
  computed: mapGetters({
    totalPrice: "totalPrice",
    numberOfItems: "numberOfItems",
  }),
};
</script>

<style lang="scss" scoped>
.number-of-items {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 10px;
  color: white;
  background-color: black;
  line-height: 17px;
  font-size: 10px;
  text-align: center;
  position: relative;
}
</style>
